export default "__VITE_ASSET__CXOmFSA2__"